import { calculateSliderTrackWidth } from '../VSlider/util';
import { type FRAME_SLIDER_SCALE, FRAME_SLIDER_SCALE_CONFIG } from './constant';

export const alignThumbToCenter = ({
  $container,
  $thumbRef,
}: {
  $container: React.RefObject<Nullish<HTMLDivElement>>;
  $thumbRef: React.RefObject<Nullish<HTMLDivElement>>;
}) => {
  if (!$container.current || !$thumbRef.current) return;

  const [container, thumb] = [$container.current, $thumbRef.current];
  const containerOffsetWidth = container.offsetWidth;
  const scrollLeft = container.scrollLeft;
  const thumbWidth = thumb.offsetWidth;
  const thumbLeft =
    thumb.getBoundingClientRect().left - container.getBoundingClientRect().left;
  const targetScrollLeft =
    thumbLeft - containerOffsetWidth / 2 + thumbWidth / 2 + scrollLeft;

  container.scrollTo({ left: targetScrollLeft });
};

export const calculateFrameSliderWidth = ({
  max,
  min,
  scale,
}: {
  max: number;
  min: number;
  scale: FRAME_SLIDER_SCALE;
}): number => {
  const { step } = getStepConfig(scale);
  const width = calculateSliderTrackWidth(max, min, step);

  return width;
};

export const getStepConfig = (scale: FRAME_SLIDER_SCALE) =>
  FRAME_SLIDER_SCALE_CONFIG[scale];
